import React from 'react'
import PrimaryTheme from '../Themes/Primary'
import Input from './Input'
import SuccessImage from "../images/Dashboard-success-icon.png"
export default function Alert(props: AlertProps) {
  return (
    <div className="col-md-12 modal-container p-5 text-center">
      <img src={SuccessImage} alt="Alert" className='mb-5' />
      <h5 style={{
        color: PrimaryTheme.success,
        fontFamily: PrimaryTheme.fonts?.RubikMedium,
        fontSize: PrimaryTheme.fontSizes?.small,
        textAlign: 'center'
      }}>{props.title}</h5>
      <p style={{
        color: PrimaryTheme.dark,
        fontFamily: PrimaryTheme.fonts?.RubikLight,
        textAlign: 'center'
      }}>{props.body}</p>

      <div className="form-group mt-3">
        <Input
          onClick={props.onClick}
          type='button'
          isInput
          value={props.value}
          style={{
            background: PrimaryTheme.warn,
            fontFamily: PrimaryTheme.fonts?.MediumFont,
          }} className='text-bold border-0 col-md-8 ml-auto mr-auto' />
      </div>
    </div>
  )
}

interface AlertProps {
  title: string;
  body?: string;
  onClick?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  value?: string;
}
